import { USER_LOGOUT, USER_LOGIN, USER_UPDATE , SET_PAGINATION} from "../actions/constants";

const userData = JSON.parse(localStorage.getItem("ccms-user"));

const defaultState = {
    authenticated: !!userData,
    userData: userData,
    paginationSize: 50
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_PAGINATION:
            return { ...state, paginationSize: action.payload || 50 };
        case USER_LOGOUT:
            return defaultState;
        case USER_LOGIN:
            return { ...state, authenticated: true, userData: action.payload };
        case USER_UPDATE:
            return { ...state, userData: action.payload };
        default:
            return state;
    }
};